// Set global log level
const LOG_LEVEL = 'info';

// Add emoji to delivery promise content using MutationObserver
(function() {
  // Only run if feature is enabled and has a value
  if (!window.features || !window.features.productShippingEstimatePrefix || window.features.productShippingEstimatePrefix === "") {
    return;
  }
  
  const logger = createLogger(true, 'delivery-emoji', LOG_LEVEL);
  const prefix = window.features.productShippingEstimatePrefix;
  
  function processDeliveryElement(element) {
    logger.info('Processing delivery element:', element);
    
    function addPrefixToText(targetElement) {
      const textContent = targetElement.textContent?.trim();
      if (textContent && textContent.length > 3 && !textContent.includes(prefix)) {
        logger.info('Adding prefix to text:', textContent);
        
        // Preserve inner HTML structure (like <u> tags) while adding prefix at the start
        const innerHTML = targetElement.innerHTML;
        if (innerHTML && innerHTML !== textContent) {
          // Has HTML structure, prepend prefix before the HTML
          targetElement.innerHTML = prefix + ' ' + innerHTML;
        } else {
          // Plain text, just prepend prefix
          targetElement.textContent = prefix + ' ' + textContent;
        }
        
        logger.info('Modified text:', targetElement.textContent);
        return true;
      }
      return false;
    }
    
    function setupShadowObserver() {
      if (!element.shadowRoot) {
        logger.info('No shadow root available');
        return;
      }
      
      logger.info('Setting up shadow DOM observer');
      
      // Try to modify existing content first - look for the specific target element
      const targetElement = element.shadowRoot.querySelector('.PromiseShell__Promise .Text__Text');
      if (targetElement) {
        logger.info('Found target element:', targetElement);
        if (addPrefixToText(targetElement)) {
          logger.info('Modified target element');
          return; // Found and modified, we're done
        }
      } else {
        logger.info('Target element .PromiseShell__Promise .Text__Text not found yet');
      }
      
      // Set up observer for future changes in shadow DOM
      const shadowObserver = new MutationObserver(mutations => {
        // Check if our target element now exists
        const targetElement = element.shadowRoot.querySelector('.PromiseShell__Promise .Text__Text');
        if (targetElement) {
          logger.info('Target element now available:', targetElement);
          if (addPrefixToText(targetElement)) {
            logger.info('Modified target element via observer');
            shadowObserver.disconnect(); // Stop observing once we've made the change
            return;
          }
        }
      });
      
      shadowObserver.observe(element.shadowRoot, {
        childList: true,
        subtree: true,
        characterData: true
      });
      
      logger.info('Shadow DOM observer active');
    }
    
    // Wait for shadow root to be available if not immediately present
    if (element.shadowRoot) {
      setupShadowObserver();
    } else {
      // Observer for when shadow root gets attached
      const shadowRootObserver = new MutationObserver(() => {
        if (element.shadowRoot) {
          logger.info('Shadow root now available');
          shadowRootObserver.disconnect();
          setupShadowObserver();
        }
      });
      
      shadowRootObserver.observe(element, {
        childList: true,
        attributes: true
      });
      
      logger.info('Waiting for shadow root to be available');
    }
  }
  
  // Process existing elements
  const existingElements = document.querySelectorAll('delivery-promise-wc');
  logger.info('Found existing delivery-promise-wc elements:', existingElements.length);
  existingElements.forEach(processDeliveryElement);
  
  // Process future elements
  const mainObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.tagName === 'DELIVERY-PROMISE-WC') {
          logger.info('New delivery-promise-wc element detected');
          processDeliveryElement(node);
        }
      });
    });
  });
  
  if (document.body) {
    mainObserver.observe(document.body, { childList: true, subtree: true });
    logger.info('Main DOM observer set up');
  } else {
    logger.error('No document.body found');
  }
})();

function waitForSwiper(trigger) {
  var interval = setInterval(function () {
      if (typeof Swiper != "undefined") {
          clearInterval(interval);
          trigger();
      }
  }, 50);
  setTimeout(function () {
      clearInterval(interval);
  }, 15000)
}

function addScript() {
  var swiperScript = document.createElement('script');
  swiperScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.0.7/js/swiper.min.js';
  document.getElementsByTagName('head')[0].appendChild(swiperScript);
}

// ATC Button Initialization
function createLogger(isDebug, instanceName, level = 'info') {
  const colors = {
    debug: "#95a5a6",
    info: "#3498db",
    success: "#2ecc71",
    error: "#e74c3c",
  };

  const levels = {
    debug: 0,
    info: 1,
    success: 2,
    error: 3
  };

  const currentLevel = levels[level] || levels.info;

  const logFn = (type, ...args) => {
    // Only log if customElementDebug is true or if it's an error
    if ((theme.customElementDebug || type === 'error') && levels[type] >= currentLevel) {
      console.log(
        `%cFD-${instanceName}`,
        `background: ${colors[type]}; color: white; padding: 2px 5px; border-radius: 3px;`,
        ...args
      );
    }
  };

  return {
    debug: (...args) => logFn("debug", ...args),
    info: (...args) => logFn("info", ...args),
    success: (...args) => logFn("success", ...args),
    error: (...args) => logFn("error", ...args),
  };
}

document.addEventListener("DOMContentLoaded", (event) => {
  const logger = createLogger(true, 'init', LOG_LEVEL);
  logger.info("DOM Content Loaded - Initializing custom functionality");
  
  // Wait for custom elements to be defined
  customElements.whenDefined('custom-color-options').then(() => {
    logger.info("Custom color options element defined");
  });

  // Initialize ATC button on page load
  const container = document.querySelector('.product-single__meta');
  if (container) {
    logger.info("Found product form, initializing ATC button");
    initializeAddToCartButton(container);
  } else {
    logger.info("No product form found on page load");
  }

  // Initialize existing style options on page load
  const existingStyleOptions = document.querySelectorAll(".custom-style-option");
  if (existingStyleOptions.length > 0) {
    logger.info(`Found existing style options on page: ${existingStyleOptions.length}`);
    const quickView = new CustomQuickView();
    quickView.initializeStyleOptions(existingStyleOptions, document);
  } else {
    logger.info("No existing style options found on page");
  }

  waitForSwiper(function(){

    var ugcSweiperVideoSlider = new Swiper('.ugc-video-section .swiper-container', {
        // Optional parameters
        direction: 'horizontal',
        spaceBetween: 20,
        slidesPerView: 4,
        roundLengths: true,
        loop: true,
        breakpoints: {
            1199: {
                slidesPerView: 3.3,
            },
            991: {
                slidesPerView: 3.3,
            },
            800: {
                slidesPerView: 2.6,
            },
            500: {
                slidesPerView: 1.2,
            },
        },
        pagination: {
            el: '.slider__pagination',
            clickable: true,
        },
    });

    var swiperOptions = {
      loop: false,
      autoplay:true,
      delay:0,
      slidesPerView: 'auto',
      speed: 5000,
      grabCursor: true,
      centeredSlides: false,
    };
    var swiper = new Swiper(".custom-swatch-slider", swiperOptions);
 });
  
  if(document.querySelectorAll(".custom-style-option").length > 0){
    // No need to hide color options here - handled by CustomColorOptions class
  }

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const promo = urlParams.get('promo');
  /*const freeGiftIDs = [44685167198435,43818201481443];
  if(promo != null && promo !='' && promo == 198435){
    AddFreeGiftProduct(44685167198435);
  }else if(promo != null && promo !='' && promo == 481443){
    AddFreeGiftProduct(43818201481443);
  }*/

  const discountCode = urlParams.get('discount_code');
  if(discountCode != null && discountCode == theme.settings.auto_discount_code && theme.settings.enable_autodiscount_code == true){
    addDiscountCodeProduct();
  }

  // Initialize cart remove functionality
  // initializeCartRemove(); // Moved to custom-elements.js as CartRemove class
});

async function addDiscountCodeProduct() {
  const cartrequest = await fetch('/cart.js');
  const cart = await cartrequest.json();

  const matchedOncart = cart.items.filter(item => item.product_id == theme.settings.autodiscount_product);
  
    if(matchedOncart.length > 0){
       const discountResponse = applyAutoDiscountCode(theme.settings.auto_discount_code);
    }else{
      let formData = {
       'items': [{
        'id': theme.settings.autodiscount_product_v_id,
        'quantity': 1,
         "properties":{
           "_isDiscountProduct":1
         }
        }]
      };
      const requestData = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      setTimeout(function(){
         const discountResponse = applyAutoDiscountCode(theme.settings.auto_discount_code);
      },300); 
    }
}

async function applyAutoDiscountCode(discountCode){
  const url = `/checkout?discount=${discountCode}`;
  let redirectUrl = `/`;
  if(theme.settings.autodiscount_redirecturl != "" && theme.settings.autodiscount_redirecturl != null){
    redirectUrl = theme.settings.autodiscount_redirecturl;
  }
  try {
     const response = await fetch(url);
     window.location=redirectUrl;
  } catch (error) {
     window.location=redirectUrl;
  }
}

async function AddFreeGiftProduct(freeGiftID){
  
  const redirectUrl = `/collections/shop-all-v3-free-shears`;

  const cartrequest = await fetch('/cart.js');
  const cart = await cartrequest.json();

  const matchedOncart = cart.items.filter(item => item.id == freeGiftID);
  if(matchedOncart.length <= 0){
      let formData = {
       'items': [{
        'id': freeGiftID,
        'quantity': 1
        }]
      };
    const requestData = await  fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
    window.location=redirectUrl;
  }else{
     window.location=redirectUrl;
  }
}


// OCU Custom Upgrades
document.addEventListener("DOMContentLoaded", (event) => {
  const logger = createLogger(true, 'ocu', LOG_LEVEL);
  function addCartButton(ocuContainer) {
    const checkoutButton = ocuContainer.querySelector('.ocu-checkout-button');

    if (checkoutButton) {
      const cartLink = document.createElement('button');
      cartLink.textContent = 'Go To Cart';
      cartLink.type = 'button';
      cartLink.className = 'fd--ocu-cart-link';
      checkoutButton.parentNode.insertBefore(cartLink, checkoutButton.nextSibling);
      cartLink.setAttribute('onclick', 'window.location.href="/cart"; return false;');
    }
  }

  function addEcodriveBanner(ocuContainer) {
    const ecodriveBanner = document.querySelector('.fd--ocu-ecodrive-banner');
    if (!ecodriveBanner) {
      console.warn('Ecodrive banner not found');
      return;
    }
    const trustBadges = ocuContainer.querySelector('.trust-badges');
    if (trustBadges) {
      trustBadges.parentNode.insertBefore(ecodriveBanner, trustBadges);
    }
  }

  const waitForOCUContainer = setInterval(() => {
      const ocuContainer = document.querySelector('.ocu-cart-container');
      if (ocuContainer) {
          clearInterval(waitForOCUContainer);
          logger.info('OCU cart container found');
          addCartButton(ocuContainer);
          addEcodriveBanner(ocuContainer);
      }
  }, 100);

});

theme.CartPopup = function() {
  const logger = createLogger(true, 'cart-popup', LOG_LEVEL);
  logger.info("CRS CartPopupInit");
  var selectors = {
      drawer: "#CartPopup",
      form: "#CartPopupForm"
  };
  function CartPopup() {
    logger.info('CRS CartPopup');
    this.container = document.querySelector(selectors.drawer);
    this.drawer = new theme.Drawers("CartPopup","cart_popup");
    this.init();
  }
  return CartPopup.prototype = Object.assign({}, CartPopup.prototype, {
      init: function() {
          logger.info('CRS init');
          document.addEventListener("ajaxProduct:added", function(evt) {
            logger.info('CRS ajaxProduct:added', evt);
            
            const drawerScrollable = this.container.querySelector('.drawer__scrollable');
            if (drawerScrollable) {
              const product = evt.detail.product;
              const productHtml = `
                <div class="cart-item">
                  <img src="${product.image}" alt="${product.title}" class="cart-item__image">
                  <div class="cart-item__details">
                    <h3 class="cart-item__title">${product.title}</h3>
                    <p class="cart-item__price">
                      ${product.original_price && product.original_price > product.final_price ?
                        `<span class="product__price product__price--compare">${theme.Currency.formatMoney(product.original_price, theme.settings.moneyFormat)}</span>
                        <br>` :
                        ''}
                      <span class="product__price product__price--sale">${theme.Currency.formatMoney(product.final_price, theme.settings.moneyFormat)}</span>
                    </p>
                  </div>
                </div>
              `;
              drawerScrollable.insertAdjacentHTML('afterbegin', productHtml);
            }
            this.open();
          }
          .bind(this)),
          document.addEventListener("bundlr:productAdded", function() {
              // this.cartForm.buildCart(),
              this.open()
          }
          .bind(this)),
          document.addEventListener("cart:open", this.open.bind(this)),
          document.addEventListener("cart:close", this.close.bind(this))
      },
      open: function() {
          logger.info('CRS open');
          this.drawer.open(),
          theme.a11y.trapFocus({
              container: this.container,
              elementToFocus: this.container,
              namespace: "cartpopup_focus"
          })
      },
      close: function() {
          logger.info('CRS close');
          this.drawer.close(),
          theme.a11y.removeTrapFocus({
              container: this.container,
              namespace: "cartpopup_focus"
          })
      }
  }),
  CartPopup
}();

if (theme.settings.cartType === "popup") {
  new theme.CartPopup();
}

// Initialize ATC button
function initializeAddToCartButton(container) {
  const logger = createLogger(true, 'init', LOG_LEVEL);
  logger.info("Initializing ATC button");
  new CustomAddToCartButton(container);
}

// Buy X Get Y Feature Manager
class BuyXGetYManager {
  constructor() {
    this.logger = createLogger(true, 'BuyXGetYManager', LOG_LEVEL);
    this.enabled = false;
    this.originalFetch = null;
    this.processingCartRequest = false;
    this.interceptorEnabled = false;
    this.errorCount = 0;
    this.maxErrors = 5; // Disable after 5 errors
  }

  enableBuyXGetY() {
    if (this.enabled) {
      this.logger.info('Buy X Get Y already enabled');
      return;
    }

    this.logger.info('Enabling Buy X Get Y feature');
    this.enabled = true;

    // Initialize cart data cache
    window.latestCart = null;

    // Set up cart.js interceptor
    this.setupCartInterceptor();

    // Define and register custom element
    this.defineCustomElement();

    this.logger.info('Buy X Get Y feature enabled successfully');
  }

  setupCartInterceptor() {
    // Store original fetch if not already stored
    if (!this.originalFetch) {
      this.originalFetch = window.fetch;
    }

    // Don't setup if already enabled or in preview mode
    if (this.interceptorEnabled || window.location.hostname.includes('.myshopify.com')) {
      this.logger.info('Interceptor already enabled or in preview mode, skipping');
      return;
    }

    this.interceptorEnabled = true;

    // Intercept all fetch requests to cache cart.js responses
    window.fetch = (...args) => {
      const [resource] = args;
      
      // Emergency disable if too many errors
      if (this.errorCount >= this.maxErrors) {
        this.logger.error('Too many errors, disabling interceptor');
        this.restoreOriginalFetch();
        return this.originalFetch.apply(window, args);
      }
      
      return this.originalFetch.apply(window, args)
        .then(response => {
          // Check if this is a cart.js request, response is ok, not from OCU, and we're not already processing
          if (typeof resource === 'string' && 
              resource.includes('/cart.js') && 
              !resource.includes('?ocu') && 
              response.ok &&
              !this.processingCartRequest &&
              this.interceptorEnabled) {
            
            // Set flag to prevent recursive processing
            this.processingCartRequest = true;
            
            try {
              // Clone the response to read it without consuming the original
              const clonedResponse = response.clone();
              clonedResponse.json().then(cartData => {
                window.latestCart = cartData;
                // Dispatch custom event that cart data is updated
                document.dispatchEvent(new CustomEvent('cart:data:updated', {
                  detail: { cart: cartData }
                }));
                // Reset flag after processing
                this.processingCartRequest = false;
              }).catch((error) => {
                // Count JSON parsing errors
                this.errorCount++;
                this.logger.error('Cart data processing error', error);
                this.processingCartRequest = false;
              });
            } catch (error) {
              this.errorCount++;
              this.logger.error('Cart interceptor error', error);
              this.processingCartRequest = false;
            }
          }
          return response;
        })
        .catch(error => {
          // Count fetch errors
          this.errorCount++;
          this.processingCartRequest = false;
          return Promise.reject(error);
        });
    };

    // Add global recovery function
    window.fdRestoreCartFetch = () => this.restoreOriginalFetch();

    this.logger.info('Cart.js interceptor enabled with safeguards');
  }

  restoreOriginalFetch() {
    if (this.originalFetch && this.interceptorEnabled) {
      window.fetch = this.originalFetch;
      this.interceptorEnabled = false;
      this.processingCartRequest = false;
      this.logger.info('Original fetch restored');
      return true;
    }
    return false;
  }

  disableBuyXGetY() {
    this.enabled = false;
    this.restoreOriginalFetch();
    this.logger.info('Buy X Get Y disabled and fetch restored');
  }

  defineCustomElement() {
    // Define the Buy X Get Y Promotional Display Custom Element
    class BuyXGetYPromo extends HTMLElement {
      constructor() {
        super();
        this.logger = createLogger(true, 'BuyXGetYPromo', LOG_LEVEL);
        this.currentQuantity = -1; // Initialize to -1 to force first update
        this.images = {};
      }
      
      connectedCallback() {
        this.logger.info('BuyXGetYPromo connected to DOM');
        this.cacheImages();
        this.setupEventListeners();
        this.updateFromLatestCart();
      }
      
      disconnectedCallback() {
        this.logger.info('BuyXGetYPromo disconnected from DOM');
        this.removeEventListeners();
        
        // Clean up any pending fetch timeout
        if (this.fetchTimeout) {
          clearTimeout(this.fetchTimeout);
        }
      }
      
      cacheImages() {
        this.images = {
          default: this.querySelector('#buyxgety-default'),
          2: this.querySelector('#buyxgety-2'),
          3: this.querySelector('#buyxgety-3'),
          4: this.querySelector('#buyxgety-4'),
          5: this.querySelector('#buyxgety-5')
        };
        
        const availableImages = Object.keys(this.images).filter(key => this.images[key]);
        this.logger.info('Cached promotional images', { availableImages });
      }
      
      setupEventListeners() {
        // Listen for our custom cart data updated event
        this.cartDataHandler = this.handleCartDataUpdate.bind(this);
        document.addEventListener('cart:data:updated', this.cartDataHandler);
        
        // Also listen for theme events as backup
        this.cartUpdateHandler = this.handleCartUpdate.bind(this);
        const events = [
          'cart:updated',
          'cart:build', 
          'ajaxProduct:added',
          'bndlr:mixnmatch:product_added',
          'bndlr:sectioned_mixnmatch:product_added',
          'bndlr:bundle_added_to_cart'
        ];
        
        events.forEach(eventName => {
          document.addEventListener(eventName, this.cartUpdateHandler);
        });
      }
      
      removeEventListeners() {
        document.removeEventListener('cart:data:updated', this.cartDataHandler);
        document.removeEventListener('cart:updated', this.cartUpdateHandler);
        document.removeEventListener('cart:build', this.cartUpdateHandler);
        document.removeEventListener('ajaxProduct:added', this.cartUpdateHandler);
        document.removeEventListener('bndlr:mixnmatch:product_added', this.cartUpdateHandler);
        document.removeEventListener('bndlr:sectioned_mixnmatch:product_added', this.cartUpdateHandler);
        document.removeEventListener('bndlr:bundle_added_to_cart', this.cartUpdateHandler);
      }
      
      handleCartDataUpdate(evt) {
        this.logger.info('Cart data updated via fetch interceptor', evt.detail.cart);
        const quantity = evt.detail.cart.item_count || 0;
        this.updateDisplay(quantity);
      }
      
      handleCartUpdate(evt) {
        this.logger.info('Cart event received', evt.type);
        
        // Try to get from event detail first
        if (evt.detail && evt.detail.cart && typeof evt.detail.cart.item_count !== 'undefined') {
          const quantity = evt.detail.cart.item_count;
          this.logger.info('Using quantity from event detail', quantity);
          this.updateDisplay(quantity);
          return;
        }
        
        // Fall back to cached cart data
        this.updateFromLatestCart();
      }
      
      updateFromLatestCart() {
        if (window.latestCart && typeof window.latestCart.item_count !== 'undefined') {
          const quantity = window.latestCart.item_count;
          this.logger.info('Using quantity from cached cart', quantity);
          this.updateDisplay(quantity);
        } else {
          // Last resort: fetch cart.js
          this.fetchCartData();
        }
      }
      
      fetchCartData() {
        // Debounce cart data fetching to prevent rapid successive calls
        if (this.fetchTimeout) {
          clearTimeout(this.fetchTimeout);
        }
        
        this.fetchTimeout = setTimeout(() => {
          this.logger.info('Fetching cart data from /cart.js');
          
          // Use a timeout to prevent hanging requests
          const controller = new AbortController();
          const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout
          
          fetch('/cart.js', { signal: controller.signal })
            .then(response => {
              clearTimeout(timeoutId);
              if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
              }
              return response.json();
            })
            .then(cart => {
              const quantity = cart.item_count || 0;
              this.logger.info('Fetched cart data', { quantity, cart });
              this.updateDisplay(quantity);
            })
            .catch(error => {
              clearTimeout(timeoutId);
              this.logger.error('Failed to fetch cart data', error);
              
              // If cart fetch fails, try to restore original fetch and retry once
              if (window.fdRestoreCartFetch && !this.retryAttempted) {
                this.retryAttempted = true;
                this.logger.info('Restoring original fetch and retrying');
                window.fdRestoreCartFetch();
                
                setTimeout(() => {
                  fetch('/cart.js')
                    .then(response => response.json())
                    .then(cart => {
                      const quantity = cart.item_count || 0;
                      this.updateDisplay(quantity);
                    })
                    .catch(() => {
                      this.updateDisplay(0);
                    });
                }, 100);
              } else {
                this.updateDisplay(0);
              }
            });
        }, 100); // 100ms debounce
      }
      
      updateDisplay(quantity) {
        if (this.currentQuantity === quantity) {
          this.logger.info('Quantity unchanged, skipping display update', quantity);
          return;
        }
        
        const previousQuantity = this.currentQuantity;
        this.currentQuantity = quantity;
        
        this.logger.info('Updating display', { from: previousQuantity, to: quantity });
        
        // Hide all images first
        Object.values(this.images).forEach(img => {
          if (img) img.style.display = 'none';
        });
        
        // Show appropriate image based on quantity
        let imageToShow = null;
        let imageKey = 'none';
        
        if (quantity >= 5 && this.images[5]) {
          imageToShow = this.images[5];
          imageKey = '5';
        } else if (quantity === 4 && this.images[4]) {
          imageToShow = this.images[4];
          imageKey = '4';
        } else if (quantity === 3 && this.images[3]) {
          imageToShow = this.images[3];
          imageKey = '3';
        } else if (quantity === 2 && this.images[2]) {
          imageToShow = this.images[2];
          imageKey = '2';
        } else if ((quantity === 0 || quantity === 1) && this.images.default) {
          imageToShow = this.images.default;
          imageKey = 'default';
        }
        
        if (imageToShow) {
          imageToShow.style.display = 'block';
          this.logger.info('Showing promotional image', { 
            imageKey, 
            imageId: imageToShow.id, 
            quantity 
          });
        } else {
          this.logger.info('No appropriate image found', { 
            quantity, 
            availableImages: Object.keys(this.images).filter(k => this.images[k]) 
          });
        }
      }
    }

    // Register the custom element
    customElements.define('buyxgety-promo', BuyXGetYPromo);
    this.logger.info('Custom element registered');
  }
}

// Initialize Buy X Get Y Manager
const buyXGetYManager = new BuyXGetYManager();

// DOM Ready initialization
function initializeBuyXGetY() {
  if (window.features && window.features.buyXGetY) {
    buyXGetYManager.enableBuyXGetY();
  } else {
    console.log('Buy X Get Y feature disabled');
  }
}

// Run initialization when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeBuyXGetY);
} else {
  initializeBuyXGetY();
}

// Clean zero discount text
function cleanZeroDiscounts() {
  const cartDrawer = document.getElementById('CartDrawer');
  if (!cartDrawer) return;
  
  cartDrawer.querySelectorAll('.cart__discount').forEach(element => {
    if (element.textContent.includes('Buy 3 Get 2 FREE (-0')) {
      element.textContent = 'Buy 3 Get 2 FREE';
    }
  });
}

// Watch for changes only in cart drawer
const cartDrawer = document.getElementById('CartDrawer');
if (cartDrawer) {
  const observer = new MutationObserver(() => {
    cleanZeroDiscounts();
  });
  
  observer.observe(cartDrawer, { childList: true, subtree: true });
  cleanZeroDiscounts();
}
